import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import ContrastSecurityConfigListing from './ContrastSecurityConfigListing'
import ContrastSecurityCredentialsForm from './ContrastSecurityCredentialsForm'

export default function ContrastSecurityPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={ContrastSecurityCredentialsForm}
            PullConfigListingView={ContrastSecurityConfigListing}
            RunOnDemandButtonText={'Sync tool Applications'}
        />
    )
}
